<template>
	<div>
		<header>
			报警时间：
			<el-date-picker
				class="picker"
				v-model="search.alarmTime"
				type="daterange" 
				placeholder="选择日期"
				value-format="yyyy-MM-dd"
				clearable
				:picker-options="pickerOptions"
			></el-date-picker>
			企业名称：
			<el-input v-model="search.companyName" placeholder="请输入企业名称" style="width: 150px"></el-input>
			项目名称：
			<el-input v-model="search.projectName" placeholder="请输入内容" style="width: 150px" clearable></el-input>
			设备异常原因：
			<el-select v-model="search.deviceAlarmType" style="width: 150px;" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in deviceAbnormalDict"
					:key="pro.value"
					:label="pro.name"
					:value="pro.value"
				>
				</el-option>
			</el-select>
			工单状态：
			<el-select v-model="search.recordType" style="width: 150px" placeholder="请选择" filterable clearable>
				<el-option
					v-for="pro in workOrderStatusDict"
					:key="pro.value"
					:label="pro.name"
					:value="pro.value"
				>
				</el-option>
			</el-select>
			<el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="pageIndex=1;onSearch()">查询</el-button>
			<el-button type="primary" icon="el-icon-top-right" style="margin-left: 10px" @click="exportHandler">导出</el-button>
		</header>
		<el-table :data="tableData" style="width: 100%;margin-top: 20px;" border>
			<el-table-column type="index" label="序号" width="80" ></el-table-column>
			<el-table-column prop="companyName" label="企业名称"></el-table-column>
			<el-table-column prop="projectName" label="项目名称"></el-table-column>
			<el-table-column prop="moduleName" label="硬件名称"></el-table-column>
			<el-table-column prop="equipmentNum" label="设备编号"></el-table-column>
			<el-table-column prop="manufacturer" label="硬件厂商"></el-table-column>
			<el-table-column prop="installTime" label="设备安装时间"></el-table-column>
			<el-table-column prop="content" label="报警内容" show-overflow-tooltip></el-table-column>
			<el-table-column prop="lastSyncTime" label="设备数据最后一次（在线）同步时间"></el-table-column>
			<el-table-column prop="createTime" label="报警时间"></el-table-column>
			<el-table-column prop="deviceAlarmText" label="设备异常原因" show-overflow-tooltip></el-table-column>
			<el-table-column prop="recordTypeText" label="工单状态"></el-table-column>
			<el-table-column prop="operateTime" label="操作时间"></el-table-column>
			<el-table-column prop="repairDetail" label="维修人员及日期"></el-table-column>
			<el-table-column prop="remarks" label="备注"></el-table-column>
			<el-table-column label="操作" align="center" width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="editReportRecord(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="tc" style="margin-top:20px">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pageIndex"
				:page-sizes="[ 10, 20, 50 ]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>
		<daliy-edit 
			:deviceAbnormalDict="deviceAbnormalDict" 
			:workOrderStatusDict="workOrderStatusDict" 
			@refreshTable="onSearch"
			ref="dailyEdit"
		></daliy-edit>
	</div>
</template>

<script>
import { getHardwareAlarmStatisticsDaily, exportHardwareDailyReport } from '@/api/hardwarestatistic';
import daliyEdit from './daliyEdit.vue';
export default {
    components: { daliyEdit },
	name: 'dailyReport',
	props: {
		deviceAbnormalDict: {
			type: Array,
			default: () => []
		},
		workOrderStatusDict: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			search: {
				alarmTime: this.getCurrentDate(),
				deviceAlarmType: "",
				recordType: "",
				companyName: "",
				projectName: ""
			},
			pageIndex: 1,
			pageSize: 10,
			total: 100,
			tableData: [],
			pickerOptions: {
                shortcuts: [{
                    text: '今天',
					onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '近7日',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '近30日',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '近90日',
					onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            }
		}
	},
	mounted() {
		this.onSearch();
	},
	methods: {
		getCurrentDate() {
			return [
				`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
				this.createTomorrowDateString()
			]
		},
		createTomorrowDateString() {
			const tomorrow = new Date();
			tomorrow.setDate(tomorrow.getDate() + 1);
			return `${tomorrow.getFullYear()}-${String(tomorrow.getMonth() + 1).padStart(2, '0')}-${String(tomorrow.getDate()).padStart(2, '0')}`;
		},
		editReportRecord(row) {
			this.$refs.dailyEdit.openDialog(row);
		},
		exportHandler() {
			let params = this.generateParams();
			delete params.pageSize;
			delete params.pageIndex;
			exportHardwareDailyReport(params).then(res => {
				if (res.data.statusCode === 200) {
					window.open(`${this.$exportPrefix}${res.data.data}`);
				}
			}).catch(() => {})
		},
		generateParams() {
			return {
				pageSize: this.pageSize,
				pageIndex: this.pageIndex,
				startTime: this.search.alarmTime&&this.search.alarmTime.length ? this.search.alarmTime[0] : this.getCurrentDate()[0],
				endTime: this.search.alarmTime&&this.search.alarmTime.length ? this.search.alarmTime[1] : this.getCurrentDate()[1],
				deviceAlarmType: this.search.deviceAlarmType!=="" ? this.search.deviceAlarmType : -1,
				recordType: this.search.recordType!=="" ? this.search.recordType : -1,
				companyName: this.search.companyName,
				projectName: this.search.projectName
			}
		},
		onSearch() {
			let params = this.generateParams();
			getHardwareAlarmStatisticsDaily(params).then(res => {
				if (res.data.statusCode === 200) {
					this.tableData = res.data.data.items;
					this.total = res.data.data.totalCount;
				}
			}).catch(() => {})
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.onSearch();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.onSearch();
		}
	}
}
</script>

<style lang="scss" scoped>

</style>